import { useBreakpoints } from "constants/constants";
import {
  useShowWorkScheduleSwitcherDropdown,
  useShowProcessGroupSwitcherDropdown,
  useShowMachineSwitcherDropdown,
} from "./topBarUtils";

/** determine which breadcrumbs to show based on tablet breakpoint
 * -> below tablet, we only show the rightmost dropdown
 */
export function useBreadcrumbDropdowns() {
  const { isTabletOrLarger } = useBreakpoints();

  const showWorkScheduleSwitcherDropdown =
    useShowWorkScheduleSwitcherDropdown();
  const showProcessGroupSwitcherDropdown =
    useShowProcessGroupSwitcherDropdown();
  const showMachineSwitcherDropdown = useShowMachineSwitcherDropdown();

  // if tablet or larger, show all dropdowns
  if (isTabletOrLarger) {
    return {
      showWSDropdown: showWorkScheduleSwitcherDropdown,
      showPGSDropdown: showProcessGroupSwitcherDropdown,
      showMSDropdown: showMachineSwitcherDropdown,
    };
  }

  // for mobile size, only show the rightmost dropdown
  const isWorkScheduleDropdownRightMost =
    !showProcessGroupSwitcherDropdown && !showMachineSwitcherDropdown;
  const isProcessGroupSwitcherDropdownRightMost =
    showProcessGroupSwitcherDropdown && !showMachineSwitcherDropdown;
  const isMachineSwitcherDropdownRightMost =
    showProcessGroupSwitcherDropdown && showMachineSwitcherDropdown;

  return {
    showWSDropdown:
      showWorkScheduleSwitcherDropdown && isWorkScheduleDropdownRightMost,
    showPGSDropdown:
      showProcessGroupSwitcherDropdown &&
      isProcessGroupSwitcherDropdownRightMost,
    showMSDropdown:
      showMachineSwitcherDropdown && isMachineSwitcherDropdownRightMost,
  };
}

export const BREADCRUMBS_GAP_REMS = 1;
